import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { authApi } from '@/api/endpoints';
import { useAuthStore } from '@/store/authStore';
import { Alert } from '@/components/common/State';
import { PasswordInput } from '@/components/common/PasswordInput';

export default function SignupPage() {
  const navigate = useNavigate();
  const login = useAuthStore((s) => s.login);

  const [form, setForm] = useState({
    email: '',
    password: '',
    passwordConfirm: '',
    name: '',
    nickname: '',
    phone: '',
    marketingAgreed: false,
  });
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const change =
    (key: keyof typeof form) =>
    (e: React.ChangeEvent<HTMLInputElement>) =>
      setForm((prev) => ({
        ...prev,
        [key]: e.target.type === 'checkbox' ? e.target.checked : e.target.value,
      }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (form.password !== form.passwordConfirm) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }

    setLoading(true);
    try {
      await authApi.signup({
        email: form.email,
        password: form.password,
        name: form.name,
        nickname: form.nickname || undefined,
        phone: form.phone || undefined,
        marketingAgreed: form.marketingAgreed,
      });
      // 가입 직후 자동 로그인
      await login(form.email, form.password);
      navigate('/', { replace: true });
    } catch (e) {
      setError(e instanceof Error ? e.message : '회원가입에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 440, margin: '40px auto' }}>
      <h1 className="panel-title" style={{ textAlign: 'center' }}>
        회원가입
      </h1>

      <div className="card">
        <form className="card__body" onSubmit={handleSubmit}>
          {error && <Alert tone="error">{error}</Alert>}

          <div className="field">
            <label htmlFor="email">이메일 *</label>
            <input id="email" type="email" className="input" required value={form.email} onChange={change('email')} />
          </div>

          <div className="field">
            <label htmlFor="password">비밀번호 * (영문+숫자 8자 이상)</label>
            <PasswordInput
              id="password"
              required
              minLength={8}
              autoComplete="new-password"
              value={form.password}
              onChange={change('password')}
            />
          </div>

          <div className="field">
            <label htmlFor="passwordConfirm">비밀번호 확인 *</label>
            <PasswordInput
              id="passwordConfirm"
              required
              autoComplete="new-password"
              value={form.passwordConfirm}
              onChange={change('passwordConfirm')}
            />
          </div>

          <div className="field">
            <label htmlFor="name">이름 *</label>
            <input id="name" className="input" required value={form.name} onChange={change('name')} />
          </div>

          <div className="field">
            <label htmlFor="nickname">닉네임</label>
            <input id="nickname" className="input" value={form.nickname} onChange={change('nickname')} />
          </div>

          <div className="field">
            <label htmlFor="phone">휴대폰</label>
            <input
              id="phone"
              className="input"
              placeholder="010-0000-0000"
              value={form.phone}
              onChange={change('phone')}
            />
          </div>

          <label style={{ display: 'flex', gap: 8, alignItems: 'center', fontSize: 14, marginBottom: 16 }}>
            <input type="checkbox" checked={form.marketingAgreed} onChange={change('marketingAgreed')} />
            마케팅 정보 수신에 동의합니다. (선택)
          </label>

          <button type="submit" className="btn btn--primary btn--lg btn--block" disabled={loading}>
            {loading ? '가입 중…' : '가입하기'}
          </button>

          <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14 }}>
            이미 계정이 있으신가요? <Link to="/login">로그인</Link>
          </p>
        </form>
      </div>
    </div>
  );
}
